<template>
  <v-container class="appButtonContainer">
      <v-layout>
        <v-flex class="appButtonCenteredContainer">
            <v-btn
              ripple
              class="appButton white--text"
              :data-testid="testId"
              :color="color"
              :loading="isLoading"
              :disabled="disabled"
              @click.native="buttonCallback()">
              <v-icon left v-if="buttonIcon && left">{{ buttonIcon }}</v-icon>
              <v-icon right v-if="buttonIcon && right">{{ buttonIcon }}</v-icon>
              {{ buttonText }}
            </v-btn>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'TheButton',
  props: {
    buttonCallback: {
      type: Function,
      default: () => '',
    },
    buttonIcon: {
      type: String,
      default: '',
    },
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#31b0e5',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    testId: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.appButtonContainer {
  padding-top: 45px;
  margin: 0;
}

.appButtonCenteredContainer{
  display: flex;
  justify-content: left;
  align-items: center; /* Submit Button is left align */
}

.appButton {
  width: 307px;
  height: 61px;
  border-radius: 5px;
  margin-top: 50px;
  display: flex;
}

 /* Tablet Break Point */
@media screen and (max-width: 1264px) {
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appButtonCenteredContainer{
  display: flex;
  justify-content: center;
  align-items: center;  /* Submit Button is centered align */
}
.appButtonContainer {
  padding-top: 0px;
}
}
</style>
